var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Mcontainer"},[_c('svg',{ref:"container",staticClass:"particle-container",attrs:{"width":"48","height":"48","viewBox":"0 0 1000 1000","xmlns":"http://www.w3.org/2000/svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }